const AlternativeFundBox = require('./AlternativeFundBox');

module.exports = AlternativeFundBox;